import React from 'react';
import { message, Spin, Upload } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { InboxOutlined } from '@ant-design/icons';
import { identifyFile } from '../utilities';
const { Dragger } = Upload;
const DataUpload = ({ onData, loading, disabled }) => {
    const draggerProps = {
        name: 'file',
        multiple: false,
        accept: '.csv',
        maxCount: 1,
        disabled: loading,
        style: { margin: 5 },
        customRequest: async (event) => {
            const fileFormat = await identifyFile(event.file);
            var reader = new FileReader();
            reader.onerror = function () {
                message.error('Could not read file');
            };
            reader.onload = function (readEvent) {
                event.onSuccess();
                onData(readEvent.target.result);
            };
            reader.readAsText(event.file, fileFormat);
        }
    };
    return (React.createElement(Dragger, { ...draggerProps, disabled: disabled },
        loading ? React.createElement(Spin, null) : React.createElement("p", { className: "ant-upload-drag-icon" },
            React.createElement(InboxOutlined, null)),
        React.createElement("p", { className: "ant-upload-text" }, _T('data.import.info')),
        React.createElement("p", { className: "ant-upload-hint" }, _T('data.import.extra'))));
};
export default DataUpload;
